import { render } from "./AppTextArea.vue?vue&type=template&id=2f9d3513&scoped=true"
import script from "./AppTextArea.vue?vue&type=script&lang=js"
export * from "./AppTextArea.vue?vue&type=script&lang=js"

import "./AppTextArea.vue?vue&type=style&index=0&id=2f9d3513&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9d3513"]])

export default __exports__